export const CodePanel = ({ code, visible, onReset }) => {
  return (
    <div className={visible ? 'row m-0 justify-content-center' : 'row m-0 justify-content-center hidden'} id="code-container">
      <div className="col-12 mt-3">
        <div className="row m-0 p-4 p-lg-5 inner-row">
          <div className="col-12 pb-4 pb-lg-5 text-center">
            <h1 className="m-0" id="code">{code}</h1>
          </div>
          <div className="col-md-6 pb-2 ps-md-0">
            <button className="btn bg-beige w-100 py-3" id="copy-main" type="button" onClick={() => navigator.clipboard.writeText(code || '')}>
              <i className="bi bi-copy" /> Copy
            </button>
          </div>
          <div className="col-md-6 pe-md-0">
            <button className="btn bg-beige w-100 py-3" id="upload-more" type="button" onClick={onReset}>Upload More</button>
          </div>
        </div>
      </div>
    </div>
  );
}

